// AUTO-GENERATED: 2025-10-28T19:10:34.717966Z
// 🍝 Italian recipes

export const italianRecipes = [
{
    name: "Spaghetti Carbonara",
    cuisine: "Italian",
    ingredients: ["spaghetti", "eggs", "pancetta", "parmesan cheese", "garlic"],
    sauces: ["black pepper", "olive oil"],
    instructions: "Cook spaghetti in salted boiling water. Fry pancetta until crispy. Beat eggs with grated parmesan. Drain pasta, reserving 1 cup pasta water. Toss hot pasta with pancetta, remove from heat. Quickly stir in egg mixture, adding pasta water to create creamy sauce. Serve immediately with more parmesan and black pepper.",
    time: "25 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Margherita Pizza",
    cuisine: "Italian",
    ingredients: ["pizza dough", "mozzarella cheese", "tomatoes", "basil"],
    sauces: ["tomato sauce", "olive oil"],
    instructions: "Preheat oven to 500°F with pizza stone if available. Roll out dough to 12-inch circle. Spread thin layer of tomato sauce. Add sliced fresh mozzarella and tomatoes. Drizzle with olive oil. Bake 10-12 minutes until crust is golden and cheese bubbles. Top with fresh basil leaves. Slice and serve hot.",
    time: "30 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Lasagna",
    cuisine: "Italian",
    ingredients: ["lasagna noodles", "ground beef", "ricotta cheese", "mozzarella cheese", "onion", "garlic"],
    sauces: ["tomato sauce", "parmesan cheese", "italian seasoning"],
    instructions: "Cook lasagna noodles. Brown beef with onions and garlic, add tomato sauce and simmer. Mix ricotta with egg and parmesan. Layer in baking dish: sauce, noodles, ricotta mixture, mozzarella. Repeat layers. Top with sauce and mozzarella. Cover with foil, bake at 375°F for 45 minutes. Uncover, bake 15 more minutes. Let rest 15 minutes before serving.",
    time: "90 min",
    difficulty: "Hard",
    points: 150,
    servings: 2
  },
{
    name: "Risotto",
    cuisine: "Italian",
    ingredients: ["arborio rice", "mushrooms", "onion", "garlic", "parmesan cheese"],
    sauces: ["white wine", "chicken broth", "butter", "olive oil"],
    instructions: "Sauté mushrooms, set aside. In same pan, cook onion and garlic in butter. Add rice, toast 2 minutes. Add wine, stir until absorbed. Add warm broth 1/2 cup at a time, stirring constantly, waiting for liquid to absorb before adding more. After 18-20 minutes, rice should be creamy. Stir in mushrooms, butter, and parmesan. Serve immediately.",
    time: "40 min",
    difficulty: "Hard",
    points: 150,
    servings: 2
  },
{
    name: "Bruschetta",
    cuisine: "Italian",
    ingredients: ["baguette", "tomatoes", "garlic", "basil", "mozzarella cheese"],
    sauces: ["olive oil", "balsamic vinegar"],
    instructions: "Slice baguette diagonally. Toast or grill until golden. Rub with cut garlic clove. Dice tomatoes, mix with chopped basil, olive oil, balsamic vinegar, salt, and pepper. Let marinate 10 minutes. Spoon tomato mixture onto toasted bread. Optionally top with fresh mozzarella. Serve immediately while bread is still warm and crispy.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Chicken Parmigiana",
    cuisine: "Italian",
    ingredients: ["chicken breast", "mozzarella cheese", "parmesan cheese", "breadcrumbs", "eggs"],
    sauces: ["tomato sauce", "marinara sauce", "olive oil"],
    instructions: "Pound chicken breasts thin. Dip in flour, then beaten eggs, then breadcrumb mixture. Fry in olive oil until golden, 3-4 minutes per side. Place in baking dish, top with marinara sauce and mozzarella. Bake at 400°F for 15 minutes until cheese melts and bubbles. Sprinkle with parmesan and basil. Serve over pasta.",
    time: "45 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Tiramisu",
    cuisine: "Italian",
    ingredients: ["ladyfinger cookies", "mascarpone cheese", "eggs", "sugar", "coffee"],
    sauces: ["cocoa powder", "coffee liqueur"],
    instructions: "Brew strong espresso, let cool. Beat egg yolks with sugar until pale. Fold in mascarpone. Whip egg whites to stiff peaks, fold into mascarpone mixture. Dip ladyfingers briefly in coffee (with optional liqueur). Layer in dish: ladyfingers, mascarpone cream. Repeat layers. Refrigerate 4+ hours. Dust with cocoa powder before serving. Keep chilled.",
    time: "30 min + 4 hrs chill",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Minestrone Soup",
    cuisine: "Italian",
    ingredients: ["tomatoes", "kidney beans", "pasta", "carrots", "celery", "onion", "garlic", "zucchini"],
    sauces: ["olive oil", "vegetable broth", "parmesan cheese"],
    instructions: "Sauté onion, garlic, carrots, and celery in olive oil. Add diced tomatoes, beans, broth, and italian herbs. Bring to boil, reduce heat, simmer 20 minutes. Add pasta and zucchini, cook until pasta is tender, about 10 minutes. Season with salt and pepper. Serve hot with grated parmesan and crusty bread.",
    time: "45 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Pesto Pasta",
    cuisine: "Italian",
    ingredients: ["pasta", "basil", "pine nuts", "garlic", "parmesan cheese"],
    sauces: ["olive oil", "pesto sauce"],
    instructions: "Blend basil, pine nuts, garlic, and parmesan in food processor. Slowly add olive oil while blending until smooth pesto forms. Cook pasta in salted boiling water until al dente. Reserve 1/2 cup pasta water. Drain pasta, toss with pesto, adding pasta water to thin if needed. Serve immediately with extra parmesan and toasted pine nuts.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Osso Buco",
    cuisine: "Italian",
    ingredients: ["veal shanks", "carrots", "celery", "onion", "garlic", "tomatoes"],
    sauces: ["white wine", "beef broth", "gremolata", "olive oil"],
    instructions: "Season veal shanks, brown in olive oil. Remove. Sauté onion, carrot, celery, and garlic. Add wine, simmer to reduce. Add tomatoes and broth. Return veal to pot. Cover, braise in 325°F oven for 2-3 hours until meat is tender and falling off bone. Make gremolata with lemon zest, parsley, and garlic. Serve veal with sauce and gremolata over risotto.",
    time: "180 min",
    difficulty: "Hard",
    points: 150,
    servings: 2,
    special: true
  }
];
